/* eslint-disable react/jsx-no-target-blank */
import { useIntl } from 'react-intl'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'
import { SidebarMenuforti } from './SidebarMenuItemForti'
import { SidebarMenuCloudSecurity } from './SidebarMenuItemCloudSecurity'

import { useAuth } from '../../../../../app/modules/auth'
import { useAppSelector } from '../../../../../redux/hooks'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const { currentUser } = useAuth()
  const ListaPermisosTenant = useAppSelector(state => state.ListPermissionSlice.Permissions)

  return (
    <>
      {
        (
          ListaPermisosTenant.includes('Home.Status') ||
          ListaPermisosTenant.includes('Home.DataUsage') ||
          ListaPermisosTenant.includes('Home.Networking') ||
          ListaPermisosTenant.includes('Home.Topology')
        ) &&
        (
          currentUser?.ListPermiso?.includes('Home.Status') ||
          currentUser?.ListPermiso?.includes('Home.DataUsage') ||
          currentUser?.ListPermiso?.includes('Home.Networking') ||
          currentUser?.ListPermiso?.includes('Home.Topology')
        ) &&
        <SidebarMenuItem
          to='/dashboard'
          icon='/media/iconos_v2/Home.svg'
          title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
          fontIcon='bi-app-indicator'
        />
      }

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-gray-100 text-uppercase f-parrafo fs-8 ls-1'>Services</span>
        </div>
      </div>
      {
        ListaPermisosTenant.includes('CC.View') && currentUser?.ListPermiso?.includes('CC.View') && (
          <SidebarMenuItem
            to='/cloudConnectivity'
            icon='/media/iconos_v2/cloud_sync_1.svg'
            title='Cloud Connectivity'
            fontIcon='bi-app-indicator'
          />
        )
      }
      {
        (
          ListaPermisosTenant.includes('Ctx.DataUsage') ||
          ListaPermisosTenant.includes('Ctx.Troubleshooting.Ping') ||
          ListaPermisosTenant.includes('Ctx.Troubleshooting.Traceroute') ||
          ListaPermisosTenant.includes('Ctx.Troubleshooting.BGP') ||
          ListaPermisosTenant.includes('Ctx.Troubleshooting.MPLS') ||
          ListaPermisosTenant.includes('Ctx.Troubleshooting.LDP') ||
          ListaPermisosTenant.includes('Ctx.BGP.Add') ||
          ListaPermisosTenant.includes('Ctx.BGP.List') ||
          ListaPermisosTenant.includes('Ctx.BGP.Delete') ||
          ListaPermisosTenant.includes('Ctx.IPSEC.List') ||
          ListaPermisosTenant.includes('Ctx.IPSEC.Add') ||
          ListaPermisosTenant.includes('Ctx.IPSEC.Delete') ||
          ListaPermisosTenant.includes('Ctx.NGFW.List') ||
          ListaPermisosTenant.includes('Ctx.NGFW.Add') ||
          ListaPermisosTenant.includes('Ctx.NGFW.Update') ||
          ListaPermisosTenant.includes('Ctx.NGFW.Delete') ||
          ListaPermisosTenant.includes('Ctx.NGFW.Entitlement.List') ||
          ListaPermisosTenant.includes('Ctx.Monitoring.View')
        ) && (
          currentUser?.ListPermiso?.includes('Ctx.DataUsage') ||
          currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.Ping') ||
          currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.Traceroute') ||
          currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.BGP') ||
          currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.MPLS') ||
          currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.LDP') ||
          currentUser?.ListPermiso?.includes('Ctx.BGP.Add') ||
          currentUser?.ListPermiso?.includes('Ctx.BGP.List') ||
          currentUser?.ListPermiso?.includes('Ctx.BGP.Delete') ||
          currentUser?.ListPermiso?.includes('Ctx.IPSEC.List') ||
          currentUser?.ListPermiso?.includes('Ctx.IPSEC.Add') ||
          currentUser?.ListPermiso?.includes('Ctx.IPSEC.Delete') ||
          currentUser?.ListPermiso?.includes('Ctx.NGFW.List') ||
          currentUser?.ListPermiso?.includes('Ctx.NGFW.Add') ||
          currentUser?.ListPermiso?.includes('Ctx.NGFW.Update') ||
          currentUser?.ListPermiso?.includes('Ctx.NGFW.Delete') ||
          currentUser?.ListPermiso?.includes('Ctx.NGFW.Entitlement.List') ||
          currentUser?.ListPermiso?.includes('Ctx.Monitoring.View')
        ) &&
        <SidebarMenuItemWithSub to='/CTX/' title='CTX HUB' icon='/media/iconos_v2/ctx_hub.svg'>
          {
            (ListaPermisosTenant.includes('Ctx.DataUsage') &&
              currentUser?.ListPermiso?.includes('Ctx.DataUsage')) &&
            <SidebarMenuItem
              to='/CTX/datatransfer'
              title='Data Usage'
              fontIcon='bi-app-indicator'
            />
          }
          {
            (
              (ListaPermisosTenant.includes('Ctx.Troubleshooting.Ping') ||
                ListaPermisosTenant.includes('Ctx.Troubleshooting.Traceroute') ||
                ListaPermisosTenant.includes('Ctx.Troubleshooting.BGP') ||
                ListaPermisosTenant.includes('Ctx.Troubleshooting.MPLS') ||
                ListaPermisosTenant.includes('Ctx.Troubleshooting.LDP')) &&
              (currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.Ping') ||
                currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.Traceroute') ||
                currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.BGP') ||
                currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.MPLS') ||
                currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.LDP'))
            ) &&
            <SidebarMenuItem
              to='/CTX/troubleshooting'
              title='Troubleshooting'
              fontIcon='bi-app-indicator'
            />
          }
          {
            (
              (ListaPermisosTenant.includes('Ctx.BGP.Add') ||
                ListaPermisosTenant.includes('Ctx.BGP.List') ||
                ListaPermisosTenant.includes('Ctx.BGP.Delete')) &&
              (currentUser?.ListPermiso?.includes('Ctx.BGP.Add') ||
                currentUser?.ListPermiso?.includes('Ctx.BGP.List') ||
                currentUser?.ListPermiso?.includes('Ctx.BGP.Delete'))
            ) &&
            <SidebarMenuItem
              to='/CTX/addBPGSegment'
              title='BGP Segment'
              fontIcon='bi-app-indicator'
            />
          }
          {
            (
              (ListaPermisosTenant.includes('Ctx.IPSEC.List') ||
                ListaPermisosTenant.includes('Ctx.IPSEC.Add') ||
                ListaPermisosTenant.includes('Ctx.IPSEC.Delete')) &&
              (currentUser?.ListPermiso?.includes('Ctx.IPSEC.List') ||
                currentUser?.ListPermiso?.includes('Ctx.IPSEC.Add') ||
                currentUser?.ListPermiso?.includes('Ctx.IPSEC.Delete'))
            ) &&
            <SidebarMenuItem
              to='/CTX/addIPSecSegment'
              title='IPSec Segment'
              fontIcon='bi-app-indicator'
            />
          }
          {
            (
              ListaPermisosTenant.includes('Ctx.Monitoring.View') &&
              currentUser?.ListPermiso?.includes('Ctx.Monitoring.View')
            ) &&
            <SidebarMenuItem
              to='/CTX/monitoring'
              title='Monitoring'
              fontIcon='bi-app-indicator'
            />
          }
          {
            (
              ListaPermisosTenant.includes('ConnectorStatus.View') &&
              currentUser?.ListPermiso?.includes('ConnectorStatus.View')
            ) &&
            <SidebarMenuItem
              to='/CTX/EdgeConnector'
              title='Connector Status'
              fontIcon='bi-app-indicator'
            />
          }
          <SidebarMenuCloudSecurity to='/CTX/cloudsecurity' title='Cloud Security'>
            {
              (
                ListaPermisosTenant.includes('Ctx.NGFW.List') ||
                ListaPermisosTenant.includes('Ctx.NGFW.Add') ||
                ListaPermisosTenant.includes('Ctx.NGFW.Update') ||
                ListaPermisosTenant.includes('Ctx.NGFW.Delete') ||
                ListaPermisosTenant.includes('Ctx.NGFW.Entitlement.List')
              ) && (
                currentUser?.ListPermiso?.includes('Ctx.NGFW.List') ||
                currentUser?.ListPermiso?.includes('Ctx.NGFW.Add') ||
                currentUser?.ListPermiso?.includes('Ctx.NGFW.Update') ||
                currentUser?.ListPermiso?.includes('Ctx.NGFW.Delete') ||
                currentUser?.ListPermiso?.includes('Ctx.NGFW.Entitlement.List')
              ) &&
              <SidebarMenuforti to='/CTX/Fortinet' title='NGFW'>
                <SidebarMenuItem
                  to='/CTX/Fortinet/FortinetDevices'
                  title='Devices'
                  fontIcon='bi-app-indicator'
                />
                {
                  currentUser?.ListPermiso?.includes('Ctx.NGFW.Entitlement.List') &&
                  <SidebarMenuItem
                    to='/CTX/Fortinet/Entitlement'
                    title='License'
                    fontIcon='bi-app-indicator'
                  />
                }
              </SidebarMenuforti>
            }
            {
              ListaPermisosTenant.includes('CSP.View') &&
              currentUser?.ListPermiso?.includes('CSP.View') &&
              <SidebarMenuItem
                to='/cspm'
                title='CSPM'
                fontIcon='bi-app-indicator'
              />
            }
          </SidebarMenuCloudSecurity>
        </SidebarMenuItemWithSub>
      }

      {
        (
          ListaPermisosTenant.includes('CTXR.License') ||
          ListaPermisosTenant.includes('CTXR.List') ||
          ListaPermisosTenant.includes('CTXR.Add') ||
          ListaPermisosTenant.includes('CTXR.Neighbor.List') ||
          ListaPermisosTenant.includes('CTXR.Neighbor.Add') ||
          ListaPermisosTenant.includes('CTXR.Neighbor.Delete') ||
          ListaPermisosTenant.includes('CTXR.Neighbor.Update') ||
          ListaPermisosTenant.includes('CTXR.Neighbor.Status') ||
          ListaPermisosTenant.includes('CTXR.Troubleshooting.Status') ||
          ListaPermisosTenant.includes('CTXR.Troubleshooting.BGP') ||
          ListaPermisosTenant.includes('CTXR.Cluster.List') ||
          ListaPermisosTenant.includes('CTXR.Cluster.Add') ||
          ListaPermisosTenant.includes('CTXR.Cluster.Edit') ||
          ListaPermisosTenant.includes('CTXR.Cluster.Delete') ||
          ListaPermisosTenant.includes('CTXR.GeneralStatus')
        ) && (
          currentUser?.ListPermiso?.includes('CTXR.License') ||
          currentUser?.ListPermiso?.includes('CTXR.List') ||
          currentUser?.ListPermiso?.includes('CTXR.Add') ||
          currentUser?.ListPermiso?.includes('CTXR.Neighbor.List') ||
          currentUser?.ListPermiso?.includes('CTXR.Neighbor.Add') ||
          currentUser?.ListPermiso?.includes('CTXR.Neighbor.Delete') ||
          currentUser?.ListPermiso?.includes('CTXR.Neighbor.Update') ||
          currentUser?.ListPermiso?.includes('CTXR.Neighbor.Status') ||
          currentUser?.ListPermiso?.includes('CTXR.Troubleshooting.Status') ||
          currentUser?.ListPermiso?.includes('CTXR.Troubleshooting.BGP') ||
          currentUser?.ListPermiso?.includes('CTXR.Cluster.List') ||
          currentUser?.ListPermiso?.includes('CTXR.Cluster.Add') ||
          currentUser?.ListPermiso?.includes('CTXR.Cluster.Edit') ||
          currentUser?.ListPermiso?.includes('CTXR.Cluster.Delete') ||
          currentUser?.ListPermiso?.includes('CTXR.GeneralStatus')
        ) &&
        <SidebarMenuItemWithSub to='/CTX-R/' title='CTX Reflector' icon='/media/iconos_v2/ctx_reflector.svg'>
          {
            ListaPermisosTenant.includes('CTXR.GeneralStatus') &&
            currentUser?.ListPermiso?.includes('CTXR.GeneralStatus') &&
            <SidebarMenuItem
              to='/CTX-R/status'
              title='Status'
              fontIcon='bi-app-indicator'
            />
          }
          {
            (
              ListaPermisosTenant.includes('CTXR.Troubleshooting.Status') ||
              ListaPermisosTenant.includes('CTXR.Troubleshooting.BGP')
            ) && (
              currentUser?.ListPermiso?.includes('CTXR.Troubleshooting.Status') ||
              currentUser?.ListPermiso?.includes('CTXR.Troubleshooting.BGP')
            ) &&
            <SidebarMenuItem
              to='/CTX-R/visibility'
              title='L3 Overview'
              fontIcon='bi-app-indicator'
            />
          }
          {
            (
              ListaPermisosTenant.includes('CTXR.List') ||
              ListaPermisosTenant.includes('CTXR.Add') ||
              ListaPermisosTenant.includes('CTXR.Cluster.List') ||
              ListaPermisosTenant.includes('CTXR.Cluster.Add') ||
              ListaPermisosTenant.includes('CTXR.Cluster.Edit') ||
              ListaPermisosTenant.includes('CTXR.Cluster.Delete') ||
              ListaPermisosTenant.includes('CTXR.License') ||
              ListaPermisosTenant.includes('CTXR.Neighbor.List') ||
              ListaPermisosTenant.includes('CTXR.Neighbor.Add') ||
              ListaPermisosTenant.includes('CTXR.Neighbor.Delete') ||
              ListaPermisosTenant.includes('CTXR.Neighbor.Update') ||
              ListaPermisosTenant.includes('CTXR.Neighbor.Status')
            ) && (
              currentUser?.ListPermiso?.includes('CTXR.List') ||
              currentUser?.ListPermiso?.includes('CTXR.Add') ||
              currentUser?.ListPermiso?.includes('CTXR.Cluster.List') ||
              currentUser?.ListPermiso?.includes('CTXR.Cluster.Add') ||
              currentUser?.ListPermiso?.includes('CTXR.Cluster.Edit') ||
              currentUser?.ListPermiso?.includes('CTXR.Cluster.Delete') ||
              currentUser?.ListPermiso?.includes('CTXR.License') ||
              currentUser?.ListPermiso?.includes('CTXR.Neighbor.List') ||
              currentUser?.ListPermiso?.includes('CTXR.Neighbor.Add') ||
              currentUser?.ListPermiso?.includes('CTXR.Neighbor.Delete') ||
              currentUser?.ListPermiso?.includes('CTXR.Neighbor.Update') ||
              currentUser?.ListPermiso?.includes('CTXR.Neighbor.Status')
            ) &&
            <SidebarMenuItemWithSub to='/CTX-R/Management' title='Management'>
              {
                currentUser?.ListPermiso?.includes('Tenant.list') &&
                <SidebarMenuItem
                  to='/CTX-R/Management/CreateLicense'
                  title='License Creation'
                  fontIcon='bi-app-indicator'
                />
              }
              {
                ListaPermisosTenant.includes('CTXR.License') &&
                currentUser?.ListPermiso?.includes('CTXR.License') &&
                <SidebarMenuItem
                  to='/CTX-R/Management/License'
                  title='Licensing'
                  fontIcon='bi-app-indicator'
                />
              }
              {
                (
                  ListaPermisosTenant.includes('CTXR.List') ||
                  ListaPermisosTenant.includes('CTXR.Add') ||
                  ListaPermisosTenant.includes('CTXR.Cluster.List') ||
                  ListaPermisosTenant.includes('CTXR.Cluster.Add') ||
                  ListaPermisosTenant.includes('CTXR.Cluster.Edit') ||
                  ListaPermisosTenant.includes('CTXR.Cluster.Delete')
                ) && (
                  currentUser?.ListPermiso?.includes('CTXR.List') ||
                  currentUser?.ListPermiso?.includes('CTXR.Add') ||
                  currentUser?.ListPermiso?.includes('CTXR.Cluster.List') ||
                  currentUser?.ListPermiso?.includes('CTXR.Cluster.Add') ||
                  currentUser?.ListPermiso?.includes('CTXR.Cluster.Edit') ||
                  currentUser?.ListPermiso?.includes('CTXR.Cluster.Delete')
                ) &&
                <SidebarMenuItem
                  to='/CTX-R/Management/Instances'
                  title='Instances'
                  fontIcon='bi-app-indicator'
                />
              }
              {
                (
                  ListaPermisosTenant.includes('CTXR.Neighbor.List') ||
                  ListaPermisosTenant.includes('CTXR.Neighbor.Add') ||
                  ListaPermisosTenant.includes('CTXR.Neighbor.Delete') ||
                  ListaPermisosTenant.includes('CTXR.Neighbor.Update') ||
                  ListaPermisosTenant.includes('CTXR.Neighbor.Status')
                ) && (
                  currentUser?.ListPermiso?.includes('CTXR.Neighbor.List') ||
                  currentUser?.ListPermiso?.includes('CTXR.Neighbor.Add') ||
                  currentUser?.ListPermiso?.includes('CTXR.Neighbor.Delete') ||
                  currentUser?.ListPermiso?.includes('CTXR.Neighbor.Update') ||
                  currentUser?.ListPermiso?.includes('CTXR.Neighbor.Status')
                ) &&
                <SidebarMenuItem
                  to='/CTX-R/Management/neighbors'
                  title='BGP'
                  fontIcon='bi-app-indicator'
                />
              }
              {
                (
                  ListaPermisosTenant.includes('CTXR.Neighbor.List') ||
                  ListaPermisosTenant.includes('CTXR.Neighbor.Add') ||
                  ListaPermisosTenant.includes('CTXR.Neighbor.Delete') ||
                  ListaPermisosTenant.includes('CTXR.Neighbor.Update') ||
                  ListaPermisosTenant.includes('CTXR.Neighbor.Status')
                ) && (
                  currentUser?.ListPermiso?.includes('CTXR.Neighbor.List') ||
                  currentUser?.ListPermiso?.includes('CTXR.Neighbor.Add') ||
                  currentUser?.ListPermiso?.includes('CTXR.Neighbor.Delete') ||
                  currentUser?.ListPermiso?.includes('CTXR.Neighbor.Update') ||
                  currentUser?.ListPermiso?.includes('CTXR.Neighbor.Status')
                ) &&
                <SidebarMenuItem
                  to='/CTX-R/Management/reporting'
                  title='Reporting'
                  fontIcon='bi-app-indicator'
                />
              }
            </SidebarMenuItemWithSub>
          }
        </SidebarMenuItemWithSub>
      }
      {
        (
          ListaPermisosTenant.includes('Accounts.Billing') ||
          ListaPermisosTenant.includes('Roles.List') ||
          ListaPermisosTenant.includes('User.Create') ||
          ListaPermisosTenant.includes('User.List') ||
          ListaPermisosTenant.includes('User.Update') ||
          ListaPermisosTenant.includes('User.Delete') ||
          ListaPermisosTenant.includes('Roles.Create') ||
          ListaPermisosTenant.includes('Roles.List') ||
          ListaPermisosTenant.includes('Roles.Update') ||
          ListaPermisosTenant.includes('Roles.Delete') ||
          ListaPermisosTenant.includes('Accounts.ActivityLog')
        ) && (
          currentUser?.ListPermiso?.includes('Accounts.Billing') ||
          currentUser?.ListPermiso?.includes('Roles.List') ||
          currentUser?.ListPermiso?.includes('User.Create') ||
          currentUser?.ListPermiso?.includes('User.List') ||
          currentUser?.ListPermiso?.includes('User.Update') ||
          currentUser?.ListPermiso?.includes('User.Delete') ||
          currentUser?.ListPermiso?.includes('Roles.Create') ||
          currentUser?.ListPermiso?.includes('Roles.List') ||
          currentUser?.ListPermiso?.includes('Roles.Update') ||
          currentUser?.ListPermiso?.includes('Roles.Delete') ||
          currentUser?.ListPermiso?.includes('Accounts.ActivityLog')
        ) &&
        <SidebarMenuItemWithSub to='/accounts/' title='Account' icon='/media/iconos_v2/Accounts.svg'>
          {
            ListaPermisosTenant.includes('Accounts.Billing') &&
            currentUser?.ListPermiso?.includes('Accounts.Billing') &&
            <SidebarMenuItem
              to='/accounts/billing'
              title='Billing'
              fontIcon='bi-app-indicator'
            />
          }
          {
            (
              ListaPermisosTenant.includes('User.Create') ||
              ListaPermisosTenant.includes('User.List') ||
              ListaPermisosTenant.includes('User.Update') ||
              ListaPermisosTenant.includes('User.Delete')
            ) && (
              currentUser?.ListPermiso?.includes('User.Create') ||
              currentUser?.ListPermiso?.includes('User.List') ||
              currentUser?.ListPermiso?.includes('User.Update') ||
              currentUser?.ListPermiso?.includes('User.Delete')
            ) &&
            <SidebarMenuItem
              to='/accounts/users'
              title='Users'
              fontIcon='bi-layers'
            />
          }
          {
            (
              currentUser?.ListPermiso?.includes('SSO.Create') ||
              currentUser?.ListPermiso?.includes('SSO.List') ||
              currentUser?.ListPermiso?.includes('SSO.Update') ||
              currentUser?.ListPermiso?.includes('SSO.Delete')
            ) &&
            <SidebarMenuItem
              to='/accounts/SSO'
              title='SSO'
              fontIcon='bi-layers'
            />
          }
          {
            currentUser?.ListPermiso?.includes('Tenant.list') &&
            <SidebarMenuItem
              to='/accounts/Tenants'
              title='Tenants'
              fontIcon='bi-layers'
            />
          }
          {
            (
              ListaPermisosTenant.includes('Roles.Create') ||
              ListaPermisosTenant.includes('Roles.List') ||
              ListaPermisosTenant.includes('Roles.Update') ||
              ListaPermisosTenant.includes('Roles.Delete')
            ) && (
              currentUser?.ListPermiso?.includes('Roles.Create') ||
              currentUser?.ListPermiso?.includes('Roles.List') ||
              currentUser?.ListPermiso?.includes('Roles.Update') ||
              currentUser?.ListPermiso?.includes('Roles.Delete')
            ) &&
            <SidebarMenuItem
              to='/accounts/roles'
              title='Roles'
              fontIcon='bi-layers'
            />
          }
          {
            currentUser?.ListPermiso?.includes('Tenant.list') &&
            <SidebarMenuItem
              to='/accounts/subscriptions'
              title='Subscriptions'
              fontIcon='bi-layers'
            />
          }
          {
            ListaPermisosTenant.includes('Accounts.ActivityLog') &&
            currentUser?.ListPermiso?.includes('Accounts.ActivityLog') &&
            <SidebarMenuItem
              to='/accounts/activitylogs'
              title='Activity Log'
              fontIcon='bi-layers'
            />
          }
        </SidebarMenuItemWithSub>
      }

      {(
        currentUser?.ListPermiso?.includes('Tenant.list') || (((ListaPermisosTenant.includes('Support.List') ||
          ListaPermisosTenant.includes('Support.Create')) &&
          (currentUser?.ListPermiso?.includes('Support.List') ||
            currentUser?.ListPermiso?.includes('Support.Create')))
        )) && (
          <SidebarMenuItemWithSub
            to='/support/'
            title='Support'
            icon='/media/iconos_v2/Support.svg'
          >
            {(currentUser?.ListPermiso?.includes('Tenant.list') || (((ListaPermisosTenant.includes('Support.Create') ||
              ListaPermisosTenant.includes('Support.List')) &&
              currentUser?.ListPermiso?.includes('Support.Create')))) && (
                <SidebarMenuItem
                  to='/support/OpenRequest'
                  title='New Request'
                  fontIcon='bi-app-indicator'
                />
              )}

            {(currentUser?.ListPermiso?.includes('Tenant.list') || ((ListaPermisosTenant.includes('Support.List') ||
              ListaPermisosTenant.includes('Support.Update')) &&
              (currentUser?.ListPermiso?.includes('Support.List') ||
                currentUser?.ListPermiso?.includes('Support.Update')))) && (
                <SidebarMenuItem
                  to='/support/SeeRequest'
                  title='Request Status'
                  fontIcon='bi-app-indicator'
                />
              )}
          </SidebarMenuItemWithSub>
        )}
    </>
  )
}

export { SidebarMenuMain }
